<template>
  <div style="height: 100vh">
    <img
      src="../../assets/logotable.png"
      style="
        position: fixed;
        top: 0.8rem;
        z-index: 9;
        height: 1.5rem;
        right: 50vw;
      "
      alt=""
    />
    <nav-bar
      title="职工诉求"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="my-nav"
    />
    <div class="box">
      <img
        src="../../assets/banner.jpg"
        style="width: 100%; height: 12rem; margin-top: 40px"
        alt=""
      />
      <div class="my-form">
        <div style="margin: 5vh 0">如您有诉求，请与我们联系</div>
        <ant-form validate-first @submit="onSubmit">
          <ant-field
            label="姓名："
            v-model="form.name"
            :readonly="true"
            placeholder="请输入内容"
          />
          <ant-field
            label="部门："
            v-model="form.company"
            :readonly="true"
            placeholder="请输入内容"
          />
          <ant-field
            label="联系方式："
            v-model="form.phone"
            required
            type="tel"
            placeholder="请输入联系方式"
            :rules="[{ pattern, message: '请填写手机号' }]"
          />
          <ant-field
            label="诉求内容："
            v-model="form.content"
            rows="6"
            autosize
            required
            type="textarea"
            maxlength="160"
            placeholder="请输入内容"
            show-word-limit
            :rules="[{ required: true, message: '请填写诉求内容' }]"
          />
          <div style="margin: 16px">
            <ant-button block type="danger" native-type="submit">
              提交
            </ant-button>
          </div>
        </ant-form>
      </div>
      <img src="../../assets/bg.png" class="bottom-img" />
    </div>
  </div>
</template>

<script>
import { NavBar, Field, Form, Button, Toast } from "vant";
import myBtn from "../../common/myBtn";
import service from "../../api/service";
//员工诉求
export default {
  name: "employeeAppeal",
  components: {
    NavBar,
    myBtn,
    AntField: Field,
    AntForm: Form,
    AntButton: Button,
  },
  created() {
    console.warn("mounted appeal");
    this.queryUserData();
  },
  data() {
    return {
      name: "",
      form: {
        phone: "",
        name: "",
        content: "",
        company:""
      },
      pattern: /\d{11}/,
    };
  },
  methods: {
    //返回
    onClickLeft() {
      this.$router.push({ path: "/home" });
    },
    onClickRight() {},
    queryUserData() {
      service
        .get("/api/xw/getUserById", {
          openId: sessionStorage.getItem("openid"),
        })
        .then((res) => {
          if (res.status === 200) {
            this.form.name = res.data.user.userName;
            this.form.phone = res.data.user.phone;
            this.form.company = res.data.user.deptName;
          }
        });
    },
    onSubmit() {
      let form = { ...this.form };
      form.isHandle = 0;
      service.post("/api/appeal", form).then((res) => {
        if (res.status === 200) {
          Toast.success("提交成功！");
          this.$router.push({ path: "/home" });
        } else {
          Toast.fail(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  position: relative;
  display: flex;
  flex-direction: column;
}

.my-form {
  margin: 1rem;
  height: 60vh;
  text-align: center;
}

.bottom-img {
  position: fixed;
  bottom: 3rem;
  right: 1rem;
  z-index: -1;
}

.my-title {
  position: fixed;
  text-align: center;
  width: 100vw;
  color: #ffffff;
  font-size: 2rem;
  top: 8rem;
}
</style>